'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color:', ';\n  width: fit-content;\n  height: fit-content;\n  padding:  ', ';\n  border-radius:  ', ';\n  border: 1px solid ', ';\n  background-color: ', ';\n  box-shadow: 0px 0px 15px -5px rgb(0,0,0,.75);\n'], ['\n  color:', ';\n  width: fit-content;\n  height: fit-content;\n  padding:  ', ';\n  border-radius:  ', ';\n  border: 1px solid ', ';\n  background-color: ', ';\n  box-shadow: 0px 0px 15px -5px rgb(0,0,0,.75);\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var color = function color(props) {
  return props.color || 'black';
};
var padding = function padding(props) {
  return props.padding || '10px';
};
var borderRadius = function borderRadius(props) {
  return props.radius || '5px';
};
var border = function border(props) {
  return props.borderBg || 'black';
};
var bg = function bg(props) {
  return props.bg || 'white';
};

var Base = _styledComponents2.default.div(_templateObject, color, padding, borderRadius, border, bg);

var Card = function Card(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children,
      bg = _ref.bg,
      color = _ref.color,
      borderBg = _ref.borderBg,
      padding = _ref.padding,
      radius = _ref.radius;
  return _react2.default.createElement(
    Base,
    {
      className: className,
      onClick: onClick,
      bg: bg,
      color: color,
      borderBg: borderBg,
      padding: padding,
      radius: radius },
    children
  );
};

exports.default = Card;